import React from 'react';
import PropTypes from 'prop-types';

class Memo extends React.Component {
  constructor(props) {
    super(props);

    const {
      memoPopup,
    } = this.props;

    this.state = { isShow: memoPopup.isShow,
      message: memoPopup.message,
      userName: memoPopup.userName,
      cell: memoPopup.cell,
    };
  }

  closeAlert() {
    this.setState({isShow: false});
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      memoPopup
    } = this.props;

    if (memoPopup.cell !== prevProps.memoPopup.cell || memoPopup.message != prevProps.memoPopup.message || memoPopup.isShow != prevProps.memoPopup.isShow) {
      this.setState({
        userName: memoPopup.userName,
        isShow: memoPopup.isShow,
        message: memoPopup.message,
        cell: memoPopup.cell
      });
    }
  }

  render() {
    const {
      userName,
      isShow,
      message
    } = this.state;

    return (
      <div className={`memo-component alert-light alert-outlined ${isShow ? 'd-block' : 'd-none'}`}>
        <div className="memo-header">
          <button aria-label="Close" className="btn-close" onClick={()=> this.closeAlert()} type="button"></button>
          <h4> {userName} </h4>
        </div>
        <div className="memo-body">
          { message }
        </div>
      </div>
    );
  }
}


Memo.propTypes = {
  memoPopup: PropTypes.object
};
export default Memo;
